export const sortTopicsByFavorites = (topic1, topic2) => topic1.isFavorite === topic2.isFavorite ? 0 : topic1.isFavorite ? -1 : 1;
export const noopTopicsSort = (_, __) => 0;